export const WebSiteIcon = () => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="24" fill="#F4E8DB" />
      <path
        d="M34 24C34 25.47 33.68 26.87 33.11 28.12C31.56 31.54 28.16 33.92 24.19 33.99C24.13 34 24.06 34 24 34C23.94 34 23.87 34 23.81 33.99C19.84 33.92 16.44 31.54 14.89 28.12C14.32 26.87 14 25.47 14 24C14 22.53 14.32 21.13 14.89 19.88C16.44 16.46 19.84 14.08 23.81 14.01C23.87 14 23.94 14 24 14C24.06 14 24.13 14 24.19 14.01C28.16 14.08 31.56 16.46 33.11 19.88C33.68 21.13 34 22.53 34 24Z"
        stroke="#D2552B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.7 24C27.7 25 27.65 25.96 27.54 26.86C27.11 30.83 25.79 33.77 24.19 33.99C24.13 34 24.06 34 24 34C23.94 34 23.87 34 23.81 33.99C22.21 33.77 20.88 30.83 20.45 26.86C20.34 25.96 20.29 25 20.29 24C20.29 23 20.34 22.04 20.45 21.14C20.88 17.17 22.21 14.23 23.81 14.01C23.87 14 23.94 14 24 14C24.06 14 24.13 14 24.19 14.01C25.79 14.23 27.11 17.17 27.54 21.14C27.65 22.04 27.7 23 27.7 24Z"
        stroke="#D2552B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.1101 19.88C31.6101 20.47 29.6901 20.91 27.5401 21.14C26.4201 21.26 25.2301 21.33 24.0001 21.33C22.7701 21.33 21.5701 21.26 20.4501 21.14C18.3001 20.91 16.3901 20.47 14.8901 19.88C16.4401 16.46 19.8401 14.08 23.8101 14.01C23.8701 14 23.9401 14 24.0001 14C24.0601 14 24.1301 14 24.1901 14.01C28.1601 14.08 31.5601 16.46 33.1101 19.88Z"
        stroke="#D2552B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.1101 28.12C31.5401 31.59 28.0501 34 24.0001 34C19.9501 34 16.4601 31.59 14.8901 28.12C16.3901 27.53 18.3001 27.09 20.4501 26.86C21.5701 26.74 22.7701 26.67 24.0001 26.67C25.2301 26.67 26.4201 26.74 27.5401 26.86C29.6901 27.09 31.6101 27.53 33.1101 28.12Z"
        stroke="#D2552B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LinkedinIcon = () => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="24" fill="#F4E8DB" />
      <path
        d="M29.6616 14H18.3384C15.9424 14 14 15.9424 14 18.3384V29.6616C14 32.0576 15.9424 34 18.3384 34H29.6616C32.0576 34 34 32.0576 34 29.6616V18.3384C34 15.9424 32.0576 14 29.6616 14Z"
        stroke="#D2552B"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path d="M20.594 21.9067H18.0669V30.0846H20.594V21.9067Z" fill="#D2552B" />
      <path
        d="M27.2319 21.7874C25.3013 21.7874 24.7156 22.9588 24.7156 22.9588V21.9067H22.1885V30.0846H24.7156V25.551C24.7156 25.1063 24.8674 23.9349 26.1039 23.9349C27.6332 23.9349 27.5681 25.5835 27.5681 25.5835V30.0954H30.0952V25.5835C30.0952 23.1106 29.1516 21.7983 27.221 21.7983L27.2319 21.7874Z"
        fill="#D2552B"
      />
      <path
        d="M19.3362 20.8113C20.1388 20.8113 20.7895 20.1606 20.7895 19.3579C20.7895 18.5552 20.1388 17.9045 19.3362 17.9045C18.5335 17.9045 17.8828 18.5552 17.8828 19.3579C17.8828 20.1606 18.5335 20.8113 19.3362 20.8113Z"
        fill="#D2552B"
      />
    </svg>
  );
};

export const FacebookIcon = () => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="24" fill="#F4E8DB" />
      <path
        d="M19.6123 14.5H28.3877C31.2056 14.5001 33.4999 16.7944 33.5 19.6123V28.3877C33.4999 31.2056 31.2056 33.4999 28.3877 33.5H19.6123C16.7944 33.4999 14.5001 31.2056 14.5 28.3877V19.6123C14.5001 16.7944 16.7944 14.5001 19.6123 14.5ZM25.6758 22.2354L25.6738 22.2129C25.6739 22.213 25.6693 22.1276 25.6768 21.9814C25.6841 21.8371 25.7034 21.6429 25.748 21.4258C25.8272 21.0406 25.9806 20.6091 26.2666 20.2451L26.3975 20.0938L26.3984 20.0928C26.7913 19.6768 27.3476 19.4395 28.0361 19.4395H29.2539V20.3916H28.0361C27.5803 20.3916 27.2818 20.5341 27.0918 20.7383H27.0908C26.845 20.9923 26.7378 21.3378 26.6855 21.584C26.6301 21.8451 26.6182 22.0866 26.6182 22.209V24.1631H29.2441V25.1152H26.6182V33.0361H28.3877C30.9477 33.036 33.036 30.9477 33.0361 28.3877V19.6123C33.036 17.0523 30.9477 14.964 28.3877 14.9639H19.6123C17.1326 14.964 15.0935 16.924 14.9785 19.376L14.9736 19.6123V28.3877C14.9737 30.9477 17.062 33.036 19.6221 33.0361H25.6758V25.1152H23.0508V24.1631H25.6758V22.2354Z"
        fill="black"
        stroke="#D2552B"
      />
    </svg>
  );
};

export const InstagramIcon = () => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="24" fill="#F4E8DB" />
      <path
        d="M19.6123 14.5H28.3877C31.2056 14.5001 33.4999 16.7944 33.5 19.6123V28.3877C33.4999 31.2056 31.2056 33.4999 28.3877 33.5H19.6123C16.7944 33.4999 14.5001 31.2056 14.5 28.3877V19.6123C14.5001 16.7944 16.7944 14.5001 19.6123 14.5ZM19.6123 14.9639C17.0523 14.964 14.964 17.0523 14.9639 19.6123V28.3877C14.964 30.9477 17.0523 33.036 19.6123 33.0361H28.3877C30.9477 33.036 33.036 30.9477 33.0361 28.3877V19.6123C33.036 17.0523 30.9477 14.964 28.3877 14.9639H19.6123Z"
        fill="#D2552B"
        stroke="#D2552B"
      />
      <path
        d="M24.005 19.3099C21.4184 19.3099 19.3101 21.4183 19.3101 24.0049C19.3101 26.5915 21.4184 28.6999 24.005 28.6999C26.5917 28.6999 28.7 26.5915 28.7 24.0049C28.7 21.4183 26.5917 19.3099 24.005 19.3099ZM24.005 27.226C22.2286 27.226 20.7742 25.7814 20.7742 23.9951C20.7742 22.2089 22.2188 20.7643 24.005 20.7643C25.7913 20.7643 27.2359 22.2089 27.2359 23.9951C27.2359 25.7814 25.7913 27.226 24.005 27.226Z"
        fill="#D2552B"
      />
      <path
        d="M29.2758 17.4846C28.6218 17.4846 28.085 18.0215 28.085 18.6754C28.085 19.3294 28.6218 19.8663 29.2758 19.8663C29.9298 19.8663 30.4666 19.3294 30.4666 18.6754C30.4666 18.0215 29.9298 17.4846 29.2758 17.4846Z"
        fill="#D2552B"
      />
    </svg>
  );
};

export const TiktokIcon = () => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="24" fill="#F4E8DB" />
      <path
        d="M21.9361 21.946C21.6863 21.9061 21.4364 21.8961 21.1866 21.8961C17.7785 21.8961 15 24.6047 15 27.943C15 31.2814 17.7785 34 21.1866 34C24.5947 34 27.3831 31.2914 27.3831 27.943"
        stroke="#D2552B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.9359 25.1145C21.6961 25.0545 21.4462 25.0245 21.1864 25.0245C19.5473 25.0245 18.208 26.3339 18.208 27.9331C18.208 29.5323 19.5473 30.8516 21.1864 30.8516C22.8254 30.8516 24.1747 29.5423 24.1747 27.9331"
        stroke="#D2552B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.1851 27.933V14"
        stroke="#D2552B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.936 25.1145V21.946"
        stroke="#D2552B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.3931 27.9331V20.2569"
        stroke="#D2552B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33 22.3358V19.4872"
        stroke="#D2552B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.1851 14H24.4749H27.3933"
        stroke="#D2552B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.3931 14C27.3931 17.0285 29.9117 19.4873 33 19.4873"
        stroke="#D2552B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33 22.3359C30.8511 22.3359 28.8822 21.5662 27.3931 20.2569"
        stroke="#D2552B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const YoutubeIcon = () => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="24" fill="#F4E8DB" />
      <path
        d="M15.0098 19.7314L14.9473 19.9893C14.8112 20.6265 14.7374 21.4882 14.7002 22.2803C14.6793 22.7247 14.6703 23.1317 14.667 23.4404V24.5947C14.6704 24.9011 14.6792 25.3046 14.7002 25.7451C14.7429 26.643 14.8343 27.63 15.0107 28.2715C15.2304 29.0575 15.8779 29.692 16.7119 29.9092H16.7129L16.9951 29.9697C17.3212 30.0282 17.7747 30.0808 18.3164 30.126C19.0245 30.185 19.8408 30.2281 20.6348 30.2588C22.222 30.3202 23.6985 30.333 23.998 30.335H24C24.2998 30.3329 25.7795 30.3201 27.3682 30.2607C28.163 30.2311 28.9801 30.1897 29.6875 30.1328C30.4091 30.0748 30.9722 30.0035 31.2852 29.9238H31.2861L31.4404 29.8779C32.0908 29.6625 32.6095 29.1893 32.875 28.5957V27.7207C32.8424 27.9093 32.8056 28.0861 32.7627 28.2441L32.7617 28.25L32.7178 28.3857C32.4794 29.0574 31.9127 29.5671 31.2188 29.749L31.2139 29.751L30.9268 29.8105C30.6075 29.8661 30.1989 29.9095 29.7598 29.9453C29.1588 29.9943 28.4513 30.0329 27.7344 30.0625C26.2998 30.1217 24.8058 30.1459 24.0039 30.1514L23.9951 30.1523V30.1514C23.1951 30.1459 21.7034 30.1208 20.2695 30.0596C19.5529 30.0289 18.8451 29.9885 18.2432 29.9375C17.6572 29.8879 17.1233 29.8247 16.7822 29.7354V29.7344C16.0406 29.5409 15.443 28.9732 15.2373 28.2344L15.2363 28.2324L15.1787 27.9951C15.0518 27.4147 14.9827 26.6565 14.9443 25.9736C14.8995 25.1766 14.8931 24.4156 14.8984 24.0195V23.9785C14.8983 23.9555 14.8976 23.9222 14.8975 23.8809C14.8972 23.7982 14.8973 23.6809 14.8984 23.5371C14.9008 23.2496 14.9078 22.8544 14.9258 22.4189C14.9608 21.5702 15.0397 20.4915 15.2354 19.7705L15.2373 19.7656L15.2803 19.6299C15.5179 18.9613 16.0898 18.4358 16.7773 18.251L16.7871 18.249L17.0752 18.1895C17.3946 18.134 17.8031 18.0905 18.2422 18.0547C18.8432 18.0057 19.551 17.967 20.2676 17.9375C21.7013 17.8784 23.1939 17.8541 23.9951 17.8486L24.0039 17.8477L23.999 18.4678L24.0039 17.8486C24.8058 17.8541 26.2998 17.8792 27.7344 17.9404C28.4515 17.971 29.1595 18.0105 29.7607 18.0615C30.3438 18.111 30.8753 18.1752 31.2148 18.2646H31.2158C31.9575 18.4579 32.5549 19.0258 32.7617 19.7656L32.7627 19.7676L32.7734 19.8076L32.7744 19.8164C32.9373 20.4216 33.019 21.2861 33.0605 22.0547C33.1042 22.8612 33.108 23.6311 33.1006 24.0322V24.0439H33.0996C33.1048 24.4403 33.0981 25.1911 33.0537 25.9805C33.0214 26.5546 32.9676 27.1821 32.876 27.7148V28.5938C32.9203 28.4945 32.9588 28.3924 32.9883 28.2871C32.9891 28.284 32.9891 28.2817 32.9893 28.2812V28.2832L33.0508 28.0264C33.1866 27.3928 33.2605 26.5416 33.2979 25.7598C33.3397 24.883 33.3334 24.1539 33.332 24.0439V24.0234L33.334 23.4434C33.3318 23.1323 33.3239 22.7237 33.3037 22.2783C33.2625 21.3702 33.1715 20.3762 32.9893 19.7314L32.9883 19.7285L32.9424 19.583C32.6872 18.8647 32.069 18.2949 31.2891 18.0918L31.2861 18.0908L31.0068 18.0303C30.6835 17.9719 30.2319 17.9192 29.6904 17.874C28.9828 17.8149 28.1654 17.772 27.3701 17.7412C26.5751 17.7105 25.8075 17.6918 25.2012 17.6807L24 17.665H23.998L22.7979 17.6807C22.1918 17.6915 21.4244 17.7096 20.6299 17.7393C19.8353 17.7689 19.0188 17.8103 18.3115 17.8672C17.5899 17.9252 17.0259 17.9965 16.7129 18.0762M15.0098 19.7314V19.7305M15.0098 19.7314V19.7295L15.0107 19.7285L15.0098 19.7305M15.0098 19.7314L15.0088 19.7305H15.0098M15.0098 19.7305C15.2128 19.0012 15.8136 18.3762 16.5605 18.1221L16.7119 18.0762V18.0752L16.7129 18.0762M16.7129 18.0762C16.7115 18.0765 16.7099 18.0769 16.709 18.0771C16.7076 18.0775 16.7065 18.078 16.7061 18.0781L16.7129 18.0762ZM26.1152 24L22.6729 25.9287V22.0703L26.1152 24Z"
        fill="#D2552B"
        stroke="#D2552B"
        strokeWidth="1.33073"
      />
    </svg>
  );
};
